export default __webpack_public_path__ + "static/media/home-header-bg.a3e79624.jpg";